
    <div (click)="close()" class="icon close-popup"><i class="fal fa-times"></i></div>
    <div class="fairness-popup-home">
      <h4 translate [translateParams]="{ user: data.username || '(Anonymous)' }">game_stats.placed_by</h4>
      <p class="date">{{ data.finishedAt | date: 'medium' }}</p>
      <div class="_20px-spacer"></div>

      <a
        class="fairness-game-id-value"
        href="#"
        (click)="close(); $event.preventDefault(); openFairness()"
        data-id="modalFairnessResult-id-value"
        >{{ 'game_stats.game_id' | translate }} {{ data._id }}</a
      >

      <div class="_20px-spacer"></div>
      <div class="fairness-values-div">
        <div>Profit</div>
        <div
          class="fairness-value"
          [ngClass]="{ 'loss-fairness': data.profit < 0, 'profit-fairness': data.profit > 0 }"
        >
          {{ data.profit | crypto: data.currency:'code':false:true }}
        </div>
      </div>
      <div class="fairness-lines"></div>
      <!--
        <div class="fairness-values-div">
          <div translate>game_stats.payout</div>
          <div class="fairness-value">{{ data.payout.toFixed(2) }}x</div>
        </div>
      -->
      <!-- <div class="fairness-lines"></div> -->
      <div class="fairness-values-div">
        <div>Wagered</div>
        <div class="fairness-value">{{ data.bet | crypto: data.currency:'code':false:true }}</div>
      </div>
      <div class="_20px-spacer"></div>
      <app-form-button class="full-width" (click)="openFairness()" data-id="modalFairnessResult-view-button">
        View verification & game info
      </app-form-button>
    </div>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/fairness-result-modal.component.ts.FairnessResultModalComponent.html